<h3 class="card-title">
    {{ titulo }}
</h3>
<p class="card-text">
    Dependência Administrativa: {{ tipo }}
</p>
<p class="card-text">
    Endereço: {{ endereco }}
</p>
<p class="card-text">
    Telefone: {{ telefone }}
</p>
<p class="card-text">
    E-mail: {{ email }}
</p>
<p class="card-text">
    Home page:
    <a *ngIf="homePage !== 'não informado'" class="link" rel="noreferrer" [attr.href]="homePage | externalHref"
        target="_blank">
        {{ homePage }}
    </a>
    <span *ngIf="homePage === 'não informado'">{{ homePage }}</span>
</p>